import axios from '@/utils/axios'

// 投诉页面数据
export function GetBlockProductList (params) {
  return axios({
    url: '/SaleV2/BlockProduct/GetBlockProductList',
    method: 'get',
    params: params
  })
}

// 投诉提交
export function DeleteBlockProduct (data) {
  return axios({
    url: '/SaleV2/BlockProduct/DeleteBlockProduct',
    method: 'post',
    data: data
  })
}
